import { AbstractApi } from '@/api/AbstractApi'
import { ChangePassword } from '@/model/profile/ChangePassword'
import { RequestResetPassword } from '@/model/profile/RequestResetPassword'
import { ResetPassword } from '@/model/profile/ResetPassword'
import { UpdateProfile } from '@/model/profile/UpdateProfile'
import request from '@/api/request'

class ProfileApi extends AbstractApi {
  async update(profile: UpdateProfile): Promise<any> {
    const route = this.generateAdminRoute({ action: 'update' })

    return request.put(route, profile)
  }

  async changePassword(profile: ChangePassword): Promise<any> {
    const route = this.generateAdminRoute({ action: 'change-password' })

    return request.put(route, profile)
  }

  async requestResetPassword(profile: RequestResetPassword): Promise<any> {
    const route = this.generateRoute({}, 'request-reset-password')

    return request.post(route, profile)
  }

  async resetPassword(profile: ResetPassword, token: string): Promise<any> {
    const route = this.generateRoute({ token }, 'reset-password')

    return request.post(route, profile)
  }

  async isPasswordResetTokenValid(token: string): Promise<any> {
    const route = this.generateRoute({ action: 'is-valid' }, 'reset-password')

    return request.post(route, { token })
  }
}

export default new ProfileApi('profile')
